import * as React from 'react';
import * as styles from './styles.css';
import { UIText1, UIHeading1 } from '@cian/ui-kit';
import { IconFunctionalHelpCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { NBSP } from '../../../constants/symbols';

export interface IIconParams {
  src: string;
  width?: number;
  height?: number;
}

export interface IIconHeadCardProps extends React.PropsWithChildren {
  icon: React.ReactElement;
  title: string;
  description: string;
  haveHelpIcon?: boolean;
}

export const IconHeadCard: React.FC<IIconHeadCardProps> = ({
  children,
  icon,
  title,
  description,
  haveHelpIcon = false,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>{icon}</div>
      <div>
        <UIHeading1>{title}</UIHeading1>
        <UIText1 color={'text-secondary-default'} data-testid="description">
          {description}
          {NBSP}
          {haveHelpIcon && (
            <div className={styles['help-icon']}>
              <IconFunctionalHelpCircle16 color="icon-secondary-default" />
            </div>
          )}
        </UIText1>
        {children}
      </div>
    </div>
  );
};

IconHeadCard.displayName = 'IconHeadCard';
